import { MainItem, Field, Lang, Alert, Address } from '../main/main.model';
import * as firebase from 'firebase/app';
import 'firebase/firestore';


export class Profile extends MainItem {

    values: {
        $key: string,
        ref: number,
        created: firebase.firestore.FieldValue,
        createdBy: string,
        updated: firebase.firestore.FieldValue,
        updatedBy: string,
        alerts: Alert[],

        synaps: any,

        status: 'pending' | 'active' | 'blocked';
        provider: 'password' | 'google.com';
        firstname: string;
        lastname: string;
        fullname: string;
        initial: string;
        agencies: string[];
        agency: string;
        email: string;
        tel: string;
        desc: Lang;
        extPhoto: string;
        role: string;
        jobTitle: string;
        signatureTemplate: string;
        facebookURL: string;
        linkedinURL: string;
        tiktokURL: string;
        youtubeURL: string;
        instagramURL: string;
        gmailSignatureSyncedAt: firebase.firestore.FieldValue;
        googleAccessToken: string;
        googleRefreshToken: string;
        googleIdToken: string;
        googleTokenUpdated: firebase.firestore.FieldValue;
        gmailAuthRequired: boolean;
        gmailAuthRequiredAt: firebase.firestore.FieldValue;
        forceLogout: boolean;
        // photo: FileRecord;
    }

    constructor(
        values: any = null
    ) {
        super(
            'users',
            {
                status: new Field({ default: 'pending' }),
                provider: new Field(),
                firstname: new Field({ label: 'Firstname', validations: { required: true } }),
                lastname: new Field({ label: 'Lastname', validations: { required: true } }),
                fullname: new Field({
                    input: 'auto',
                    autoFn: {
                        toFB: (fields) => { return (fields.provider == 'password' || fields.status == 'pending') ? fields.firstname + ' ' + fields.lastname : fields.fullname },
                        // fromFB: (fields) => { return fields.fullname }
                    }
                }),
                initial: new Field(),
                email: new Field({ label: 'Email', validations: { required: true, email: true } }),
                tel: new Field({ label: 'Tel' }),
                desc: new Field({ multiLang: true, input: 'textarea', label: 'Description' }),
                extPhoto: new Field(),
                role: new Field({ label: 'Role', validations: { required: true }, input: 'select', inputOptions: { param: 'userRoles' } }),
                jobTitle: new Field({ label: 'Job Title', validations: { required: true } }),
                signatureTemplate: new Field({ label: 'Email Signature', input: 'select', inputOptions: { param: 'emailSignatureTemplates' }, validations: { required: true }, default: 'nestenn' }),
                agencies: new Field({ label: 'Agencies', validations: { required: true }, input: 'select', inputOptions: { param: 'agencies', multi: true } }),
                agency: new Field({ label: 'Main Agency', validations: { required: true }, input: 'select', inputOptions: { param: 'agencies' } }),
                facebookURL: new Field({ label: 'Facebook URL', input: 'text' }),
                linkedinURL: new Field({ label: 'LinkedIn URL', input: 'text' }),
                tiktokURL: new Field({ label: 'TikTok URL', input: 'text' }),
                youtubeURL: new Field({ label: 'YouTube URL', input: 'text' }),
                instagramURL: new Field({ label: 'Instagram URL', input: 'text' }),
                photo: new Field({ input: 'image', label: 'Photo' }),
                googleRefreshToken: new Field({ show: () => false }),
                gmailSignatureSyncedAt: new Field({ show: () => false }),
                forceLogout: new Field({ input: 'boolean', show: () => false }),
            },
            {
                password: {
                    title: 'User Details',
                    fields: ['firstname', 'lastname', 'email', 'tel', 'agencies', 'agency', 'role']
                },
                external: {
                    title: 'User Details',
                    fields: ['tel', 'agency', 'agencies', 'role', 'jobTitle', 'signatureTemplate']
                },
                new: {
                    title: 'User Details',
                    fields: ['firstname', 'lastname', 'email']
                },
                user: {
                    title: 'User Details',
                    fields: ['facebookURL', 'linkedinURL', 'tiktokURL', 'youtubeURL', 'instagramURL']
                },
                director: {
                    title: 'User Details',
                    fields: ['jobTitle', 'tel', 'facebookURL', 'linkedinURL', 'youtubeURL', 'instagramURL', 'tiktokURL', 'signatureTemplate']
                },
                admin: {
                    title: 'User Details',
                    fields: ['role', 'agencies', 'agency', 'jobTitle', 'tel', 'facebookURL', 'linkedinURL', 'youtubeURL', 'instagramURL', 'tiktokURL', 'signatureTemplate']
                },
            },
            {},
            { path: 'users/', filename: () => 'user' },
            null
        );
        if (values) {
            this.fromFB(values);
        }

    }
}

export class Agency extends MainItem {

    values: {
        $key: string,
        ref: number,
        created: firebase.firestore.FieldValue,
        createdBy: string,
        updated: firebase.firestore.FieldValue,
        updatedBy: string,
        alerts: Alert[],

        synaps: any,

        id: string,
        status: 'active' | 'blocked';
        name: string;
        email: string;
        tel: string;
        address: Address;
        addressDisplay: string;
        desc: Lang;
        websiteURL: string;
        facebookURL: string;
        linkedinURL: string;
        tiktokURL: string;
        youtubeURL: string;
        instagramURL: string;
        gmapURL: string;
    }

    constructor(
        values: any = null,
    ) {
        super(
            'agencies',
            {
                id: new Field({ label: 'ID', validations: { required: true } }),
                status: new Field({ default: 'active' }),
                name: new Field({ label: 'Name', validations: { required: true } }),
                email: new Field({ label: 'Email', validations: { required: true, email: true } }),
                tel: new Field({ label: 'Tel' }),
                address: new Field({
                    label: 'Address',
                    input: 'objectSub',
                    sub: new AgencyAddressFields(),
                }),
                addressDisplay: new Field({
                    label: 'Address Display',
                    validation: { required: true },
                }),
                desc: new Field({ multiLang: true, input: 'textarea', label: 'Description' }),
                websiteURL: new Field({ label: 'Website', default: 'https://www.nestenn.mu' }),
                gmapURL: new Field({ label: 'Google Maps URL' }),
                facebookURL: new Field({ label: 'Facebook URL', default: 'https://www.facebook.com/NestennIleMaurice/' }),
                linkedinURL: new Field({ label: 'LinkedIn URL', default: 'https://www.linkedin.com/company/nestennimmobilier/' }),
                tiktokURL: new Field({ label: 'TikTok URL', default: 'https://www.tiktok.com/@nestennimmobiliermaurice' }),
                youtubeURL: new Field({ label: 'YouTube URL', default: 'http://www.youtube.com/@NestennImmobilierIleMaurice' }),
                instagramURL: new Field({ label: 'Instagram URL', default: 'https://www.instagram.com/nestennimmobiliermaurice/' }),

            },
            {
                main: {
                    title: 'Agency Details',
                    fields: ['name', 'email', 'tel', 'addressDisplay', 'websiteURL', 'facebookURL', 'linkedinURL', 'tiktokURL', 'youtubeURL', 'instagramURL', 'desc']
                },
                admin: {
                    title: 'Agency Details',
                    fields: ['name', 'id', 'email', 'tel', 'addressDisplay', 'websiteURL', 'facebookURL', 'linkedinURL', 'tiktokURL', 'youtubeURL', 'instagramURL', 'desc']
                },
            },
            {},
            { path: 'agencies/', filename: () => 'agency' },
            null
        );
        if (values) {
            this.fromFB(values);
        }

    }
}

export class AgencyAddressFields {
    unitNb = new Field({ label: 'Unit Number' });
    streetNb = new Field({ label: 'Street Number' });
    street = new Field({ label: 'Street' });
    city = new Field({ label: 'City' });
    postcode = new Field({ label: 'Postcode' });
    // district = new Field({ label: 'Region', show: () => false });
    country = new Field({ label: 'Country', default: 'Mauritius', show: () => false });
    gps = new Field({
        input: 'gps', label: 'GPS',
        show: () => false
    });
    // sectors = new Field({
    //     input: 'arrayValue',
    //     show: () => false
    // });
    // sector = new Field({ show: () => false });
}
